import React from "react";
import StaticQRGenerator from "../../StaticQR/StaticQRGenerator";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";

export default function DownloadDialog({ targetUrl, open, setOpen }) {
    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg" keepMounted={true}> 
            <DialogTitle>Download QR Code</DialogTitle>
            <DialogContent>
                <StaticQRGenerator existingURL={targetUrl} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
